var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewdetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4788 13.4207H2.92285C2.35923 13.4207 1.90234 12.9639 1.90234 12.4003C1.90234 11.8367 2.35923 11.3799 2.92285 11.3799H21.4788C22.0424 11.3799 22.4993 11.8367 22.4993 12.4003C22.4993 12.9639 22.0424 13.4207 21.4788 13.4207Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0243 18.8784C15.4607 18.8794 15.003 18.4234 15.002 17.8598C15.0017 17.7255 15.028 17.5925 15.0793 17.4684C15.1305 17.3443 15.2058 17.2315 15.3008 17.1365L20.038 12.4007L15.3008 7.66488C15.1149 7.47243 15.012 7.21466 15.0143 6.94711C15.0167 6.67956 15.124 6.42362 15.3132 6.23442C15.5024 6.04523 15.7584 5.93791 16.0259 5.93559C16.2935 5.93326 16.5513 6.03611 16.7438 6.22199L22.2015 11.6793C22.5999 12.0777 22.5999 12.7237 22.2015 13.1221L16.7438 18.5794C16.553 18.7703 16.2942 18.8779 16.0243 18.8784Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewdetails);
export default __webpack_public_path__ + "static/media/viewdetails.04bca40d15b431c3342f8f891f87b173.svg";
export { ForwardRef as ReactComponent };